import { Navigate } from 'react-router-dom';

import OnboardingWizard from '@/pages/OnboardingWizard/OnboardingWizard';
import { useAuth } from '@/store/auth/auth.store';

/**
 * Full-screen onboarding page, mounted outside <Layout/> so it has no app chrome
 * and the Layout gate can't loop into it. Guards itself: unauthed → /auth, already
 * onboarded → /dashboard. The `onboarded` flag only flips on the wizard's final
 * "Go to dashboard" click (which navigates away), so the finish screen stays put.
 */
export const OnboardingRoute = () => {
  const session = useAuth((s) => s.session);
  const isInitializing = useAuth((s) => s.isInitializing);
  if (isInitializing) return null;
  if (!session) return <Navigate to="/auth" replace />;
  if (session.onboarded) return <Navigate to="/dashboard" replace />;
  return <OnboardingWizard />;
};
